import { scrollToId } from "./scrollHelpers.js";

export function handleAnchoredUrl(hash) {
  if (hash) {
    const el = document.querySelector(hash);
    const isAccordion =
      el.classList.contains("js-accordion-link") &&
      !el.parentNode.classList.contains("is-open");

    isAccordion && el.click();

    scrollToId(hash);
  }
}
